import * as Models from 'contracts/models';

export const Endpoint = () => `/api/v3/reports/scanstatistic/`;
export const QueryKey = (payload: Payload | undefined) => ['v3', 'reports', 'scanstatistic', payload].filter(Boolean);
export type Payload = {
    date_from: string;
    date_to: string;
};

export type Response = {
    result: Models.Scans.Statistics;
};
